import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class NonBillableConceptsModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
}
